import React from 'react';
import { Analyze } from '../components';

export const Page: React.FC = () => {
  return <Analyze />;
};
